import React from 'react';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import Aboutmylo from '../../src/components/AboutusPage/Aboutmylo';
import Superpower from '../../src/components/AboutusPage/Superpower';
import Amazingtopics from '../../src/components/AboutusPage/Amazingtopics';
import PlayStore from '../../src/components/HomePage/PlayStore';
import GlobalStyle from '../../src/styles/globalStylesV2';
import NewFooter from '../../src/components/HomePage/NewFooter';

export default function index() {
  return (
    <div>
      <GlobalStyle />
      <NewHeader nostrip={true} />
      <HomeWrapper>
        <Aboutmylo />
        <Amazingtopics />
        <Superpower />
        <PlayStore />
      </HomeWrapper>
      <NewFooter />
    </div>
  );
}
